import styled from "@emotion/styled";
import classNames from "classnames";
import type { HTMLAttributes } from "react";

import { DROPZONE_PADDING } from "./constants";

type Props = HTMLAttributes<HTMLDivElement> & {
  lineStart?: "arrow" | "dot";
  lineEnd?: "arrow" | "dot";
};

export const EffectConnector = ({ lineEnd, lineStart, ...domAttrs }: Props) => {
  return (
    <RowContainer {...domAttrs}>
      <Connector
        className={classNames({
          endArrow: lineEnd === "arrow",
          endDot: lineEnd === "dot",
          startArrow: lineStart === "arrow",
          startDot: lineStart === "dot",
        })}
      />
    </RowContainer>
  );
};

const RowContainer = styled.div`
  height: 30px;
  width: 100%;
  overflow: hidden;
`;

const Connector = styled.div`
  position: relative;
  width: 1px;
  height: 100%;
  margin-left: ${DROPZONE_PADDING * 2 - 5}px;
  background: ${({ theme }) => theme.outlineMedium};

  &.endArrow {
    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 1.2px;
      width: 1px;
      height: 4px;
      background: ${({ theme }) => theme.outlineMedium};
      transform: rotate(40deg);
    }
    &:before {
      content: "";
      position: absolute;
      bottom: 0;
      left: -1.2px;
      width: 1px;
      height: 4px;
      background: ${({ theme }) => theme.outlineMedium};
      transform: rotate(-40deg);
    }
  }
  &.endDot {
    &:after {
      content: "";
      position: absolute;
      bottom: -2px;
      left: -2px;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: ${({ theme }) => theme.outlineMedium};
    }
  }
  &.startDot {
    &:after {
      content: "";
      position: absolute;
      top: -2px;
      left: -2px;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: ${({ theme }) => theme.outlineMedium};
    }
  }
`;
